var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.94 4.485c-1.63 7.54 3.75 12.41 7.66 13.8a7.993 7.993 0 0 1-4.93 1.71c-4.41 0-8-3.59-8-8 0-3.45 2.2-6.4 5.27-7.51Zm2.72-2.48c-5.59 0-9.99 4.53-9.99 9.99 0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.97h-.35Z",
  fill: "#000"
})));
export default SvgMoon;